<template>
  <svg
    class="vessel-course-unknown-danger-icon"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7405_3177)">
      <g class="auto-cognition-frame">
        <path
          d="M0 10.8887L0 -0.000217438H10.8889V1.55534H1.55556L1.55556 10.8887H0Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
        <path
          d="M10.8889 28.0005H-3.43323e-05L-3.43323e-05 17.1116H1.55552L1.55552 26.4449H10.8889V28.0005Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
        <path
          d="M17.1112 0L28.0001 0V10.8889H26.4445V1.55556H17.1112V0Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
        <path
          d="M28.0002 17.1116V28.0005H17.1113V26.4449H26.4446V17.1116H28.0002Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
      </g>
      <path
        d="M9.41152 17.4438C9.82305 19.1626 10.2757 19.9999 10.2757 19.9999H17.8477C17.8477 19.9999 18.3004 19.1626 18.6296 17.4438C18.9588 15.7251 19 14.4912 19 14.4912L13.8971 12.7725L9 14.6675C9 14.6675 9 15.7251 9.41152 17.4438Z"
        fill="#EB5757"
        fill-opacity="0.8"
      />
      <path
        d="M10.6461 10.7835V13.3836L13.8971 12.1496L17.2305 13.2955L17.107 10.7835C17.107 10.7835 15.9947 10.3782 15.2552 10.2547C14.1754 10.0742 13.1564 10.1224 12.4568 10.2547C11.7572 10.3869 10.6461 10.7835 10.6461 10.7835Z"
        fill="#EB5757"
        fill-opacity="0.8"
      />
      <path
        d="M12.457 8.08814C12.457 8.08814 13.3089 8 13.8562 8C14.4036 8 15.2554 8.08814 15.2554 8.08814V9.67465C15.2554 9.67465 14.4036 9.58651 13.8562 9.58651C13.3089 9.58651 12.457 9.67465 12.457 9.67465V8.08814Z"
        fill="#EB5757"
        fill-opacity="0.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_7405_3177">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "VesselCourseUnknownDangerIcon",
};
</script>
